import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { AdresseService } from '../../../services/AdresseService';

interface Props {
    disabled: boolean;
    adresse: ReqType.Adresse;
    setAdresse: (adresse: ReqType.Adresse) => void;
}

interface State {
}

export class AdresseForm extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="form-group">
                <div>
                    <input
                        className="form-control-lg col-12"
                        placeholder="Intitulé"
                        style={{marginBottom: '5px'}}
                        type="text"
                        disabled={this.props.disabled}
                        value={this.props.adresse.complement}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                const newAdresse = AdresseService.getInstance().duplicateAdresse(this.props.adresse);
                                newAdresse.complement = e.target.value;
                                this.props.setAdresse(newAdresse);
                            }
                        }
                    />
                    <input
                        className="form-control-lg col-2"
                        placeholder="N°"
                        style={{marginBottom: '5px'}}
                        type="text"
                        disabled={this.props.disabled}
                        value={this.props.adresse.numero}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                const newAdresse = AdresseService.getInstance().duplicateAdresse(this.props.adresse);
                                newAdresse.numero = e.target.value;
                                this.props.setAdresse(newAdresse);
                            }
                        }
                    />
                    <input
                        className="form-control-lg offset-1 col-9"
                        placeholder="Rue"
                        style={{marginBottom: '5px'}}
                        type="text"
                        disabled={this.props.disabled}
                        value={this.props.adresse.rue}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                const newAdresse = AdresseService.getInstance().duplicateAdresse(this.props.adresse);
                                newAdresse.rue = e.target.value;
                                this.props.setAdresse(newAdresse);
                            }
                        }
                    />
                    <input
                        className="form-control-lg col-4"
                        placeholder="Code Postal"
                        type="text"
                        disabled={this.props.disabled}
                        value={this.props.adresse.code_postal}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                const newAdresse = AdresseService.getInstance().duplicateAdresse(this.props.adresse);
                                newAdresse.code_postal = e.target.value;
                                this.props.setAdresse(newAdresse);
                            }
                        }
                    />
                    <input
                        className="form-control-lg offset-1 col-7"
                        placeholder="Ville"
                        type="text"
                        disabled={this.props.disabled}
                        value={this.props.adresse.ville}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                const newAdresse = AdresseService.getInstance().duplicateAdresse(this.props.adresse);
                                newAdresse.ville = e.target.value;
                                this.props.setAdresse(newAdresse);
                            }
                        }
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/AdresseForm/AdresseForm.tsx